
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:inline-flex;
  vertical-align:middle;
}
.btn{
  padding:0 !important;
}
::slotted(.button__trigger){
  display:flex;
  padding:var(--outline-btn-padding);
}
::slotted(.button__has_menu){
  padding-right:calc(var(--outline-btn-outline-width) + 2px);
}
::slotted(.icon__trigger){
  display:flex;
  height:100%;
}
::slotted(.icon__bordered){
  border-left:1px solid currentColor;
}
.btn.none{
  z-index:30;
}
`;